import i18n from 'i18next'
import k from './../../i18n/keys' // Material-UI Avatar lib
import Avatar from '@mui/material/Avatar'
import { styled } from '@mui/material/styles'
import React from 'react'
import { Typography } from '@evocolabs/orkaui'
import { grey } from '@mui/material/colors'
const PREFIX = 'AccountAvatar'

const classes = {
  root: `${PREFIX}-root`,
  black: `${PREFIX}-black`,
  tabWidth: `${PREFIX}-tabWidth`,
  divAva: `${PREFIX}-divAva`
}

const Root = styled('div')(() => ({
  [`& .${classes.root}`]: {
    display: 'flex'
  },

  [`& .${classes.black}`]: {
    background: grey[900]
  },

  [`&.${classes.tabWidth}`]: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 15,
    padding: '24px'
  },

  [`& .${classes.divAva}`]: {
    // width: '6%',
    height: 40
  }
}))

const AccountAvatar = (props) => {
  // fetch information from server
  // tmporarily hardcoded information
  const info = props.info
  // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX//

  const userNameToDisplay = info.firstName ? info.firstName : 'Orka user'
  return (
    <Root className={classes.tabWidth}>
      <div>
        <div className={classes.divAva}>
          <div className={classes.root}>
            <Avatar className={classes.black}>
              {info.firstName ? info.firstName.substring(0, 1) : i18n.t(k.O)}
            </Avatar>
          </div>
        </div>
      </div>
      <div
        style={{
          paddingLeft: 16,
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography variant="T2" style={{ fontSize: 18, fontWeight: 600 }}>
          {'Hello ' + userNameToDisplay + ','}
        </Typography>
        <Typography variant="body3">{i18n.t(k.HOW_ARE_YOU)}</Typography>
      </div>
    </Root>
  )
}

export default AccountAvatar
